import React from "react";
import GoogleMapSelector from "../../tripManagement/addtrip/GoogleMapSelector";

const MapSelector = (props) => {
  return <GoogleMapSelector {...props} />;
};

export default MapSelector;